import { ComingSoonPanel, IconAudit, PageHeader } from '@shared/ui';

export function AuditPage() {
    return (
        <>
            <PageHeader
                eyebrow="Tenants"
                title="Audit Log"
                description="Append-only record of every configuration change — who, what, when, and why. Filter by employee, tenant, or entity."
            />
            <ComingSoonPanel
                icon={<IconAudit className="size-6" />}
                title="Audit log"
                blurb="The append-only, filterable change log (every mutation across flags, add-ons, and access) lands here as part of the Phase 0 audit foundation."
            />
        </>
    );
}
